import { savedConditionsDeleteTypes } from "../../ActionTypes/savedConditionsDeleteTypes";
import { SavedConditionsDeleteActions, SavedConditionsDeleteState } from "../../types/type";

const initialState: SavedConditionsDeleteState = {
  pending: false,
  savedConditionsDelete: [],
  error: null,
};

export default (state = initialState, action: SavedConditionsDeleteActions,) => {
  switch (action.type) {
    case savedConditionsDeleteTypes.FETCH_SAVED_CONDITIONS_DELETE_REQUEST:
      return {
        ...state,
        pending: false
      };
    case savedConditionsDeleteTypes.FETCH_SAVED_CONDITIONS_DELETE_SUCCESS:
      return {
        ...state,
        pending: true,
        savedConditionsDelete: action.payload.savedConditionsDelete,
        error: null
      };
    case savedConditionsDeleteTypes.FETCH_SAVED_CONDITIONS_DELETE_FAILURE:
      return {
        ...state,
        pending: false,
        savedConditionsDelete: [],
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
